import React from 'react'

import Burberrylux from "../images/Burberry lux.jpg";
import briellagold from "../images/Briella gold.jpg";
import faimacoffee from "../images/Faima Coffee.jpg";
import swedencopper from "../images/Sweden Copper.jpg";


import Taisagold from "../images/Taisa Gold.jpg";
import ZhuriBlue from "../images/Zhuri Blue.jpg";
import Olbeiasparkle from "../images/Olbia Sparkle.jpg"
import Majesticsdove from "../images/Majestic Dove.jpg";

import Adlergreymarble from "../images/Adler Grey Marble.jpg";
import Almanoir from "../images/Alma Noir.jpg";
import Aritmisblue from "../images/Aritmis Blue.jpg"
import devongris from "../images/Devon Gris.jpg";

import Ladygaduvagold from "../images/Lady Gudiva Gold.jpg"
import Ladygaduvasilver from "../images/LAdy Gudiva Silver.jpg"
import marfilnatural from "../images/Marfil Natural.jpg"
import matisse from "../images/Matisse.jpg"

import Mercuryrust from "../images/Mercury Rust.jpg";
import nuvogriege from "../images/Nuvo Griege.jpg"
import onicelight from "../images/Onice Light.jpg"
import pianogrey from "../images/Piano Grey.jpg"

import pilpisbeige from "../images/Pulpis Beige.jpg"
import reniornaturale from "../images/Renior Naturale.jpg"
import revivalgold from "../images/Revival Gold.jpg"
import sperisgrey from "../images/Speris Grey.jpg"


import alfred from "../images/Alfred.jpg"
import amarisgrey from "../images/Amaris Grey.jpg";
import belgian from "../images/Belgian.jpg";
import Breccia from "../images/Breccia Natural.jpg";

import coleurmarble from "../images/Coleur Marbel.jpg";
import colorealmarbel from "../images/Como Real Marbel.jpg";
import dolowhitemarble from '../images/Dolo White Marbel.jpg';
import evancrema from "../images/Evan Crema.jpg"

import grecomarble from "../images/Greco Marbel.jpg";
import harrodsgrey from "../images/Harrods Grey.jpg";
import hessiantaupe from "../images/Hessian Taupe.jpg";


import Navbar from '../inc/Navbar';
import {Link} from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
function KajariaNouvellapage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <div className='hardwarekarimpur'>
                    <div className="album py-1">
                        <div className="container mt-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Kajaria Nouvelle,
80x160cm<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                        <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                    </svg> </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    </div>
       <div className="album py-1">
        <div className="container">

          <h1 className='mb-0'><b><b style={{ color: "#001284ff" }}>Kajaria</b> Nouvelle</b></h1>
          <p className='mb-0'><small> 80x160cm, Unveiling the futuristic collection </small></p>

        </div>

      </div>
      <ScrollToTop smooth top="100" color="Darkblue"/>
               <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Burberrylux} className="card-img-top" alt="Burberrylux" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Burberry Lux </h5>
                                            <p className="card-text">80X160cm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={briellagold} className="card-img-top" alt="briellagold" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Briella Gold</h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={faimacoffee} className="card-img-top" alt="faimacoffee" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Faima Coffee </h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                            
                                        <div className="card">
                                            <Zoom>
                                                <img src={swedencopper} className="card-img-top" alt="swedencopper" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Sweden Copper                                 </h5>
                                                <p className="card-text">80X160cm</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>

                                               
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
  <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Taisagold} className="card-img-top" alt="Taisagold"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Taisa Gold </h5>
                                            <p className="card-text">80X160cm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={ZhuriBlue} className="card-img-top" alt="ZhuriBlue"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Zhuri Blue</h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Olbeiasparkle} className="card-img-top" alt="Olbeiasparkle" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Olbia Sparkle </h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                            
                                        <div className="card">
                                            <Zoom>
                                                <img src={Majesticsdove} className="card-img-top" alt="swedencopper" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Majestic Dove                             </h5>
                                                <p className="card-text">80X160cm</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>

                                               
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



 <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Adlergreymarble} className="card-img-top" alt="Adlergreymarble"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Adler Grey Marble </h5>
                                            <p className="card-text">80X160cm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Almanoir} className="card-img-top" alt="Almanoir"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Alma Noir</h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Aritmisblue} className="card-img-top" alt="Aritmisblue" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Aritmis Blue </h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                            
                                        <div className="card">
                                            <Zoom>
                                                <img src={devongris} className="card-img-top" alt="devongris" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Devon Gris                            </h5>
                                                <p className="card-text">80X160cm</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>

                                               
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

             <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Ladygaduvagold} className="card-img-top" alt="Ladygaduvagold"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Lady Gudiva Gold </h5>
                                            <p className="card-text">80X160cm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Ladygaduvasilver} className="card-img-top" alt="Ladygaduvasilver"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Lady Gudiva Silver</h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={marfilnatural} className="card-img-top" alt="marfilnatural" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Marfil Natural </h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                            
                                        <div className="card">
                                            <Zoom>
                                                <img src={matisse} className="card-img-top" alt="matisse"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Matisse Bianca                         </h5>
                                                <p className="card-text">80X160cm</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>

                                               
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

 <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Mercuryrust} className="card-img-top" alt="Mercuryrust"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Mercury Rust </h5>
                                            <p className="card-text">80X160cm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={nuvogriege} className="card-img-top" alt="nuvogriege"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Nuvo Griege</h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={onicelight} className="card-img-top" alt="onicelight"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Onice Light </h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                            
                                        <div className="card">
                                            <Zoom>
                                                <img src={pianogrey} className="card-img-top" alt="pianogrey"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Piano Grey                         </h5>
                                                <p className="card-text">80X160cm</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>

                                               
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

             <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={pilpisbeige} className="card-img-top" alt="pilpisbeige"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Pulpis Beige </h5>
                                            <p className="card-text">80X160cm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={reniornaturale} className="card-img-top" alt="reniornaturale"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Renoir Natruale</h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={revivalgold} className="card-img-top" alt="revivalgold"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Revival Gold </h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                            
                                        <div className="card">
                                            <Zoom>
                                                <img src={sperisgrey} className="card-img-top" alt="sperisgrey"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Speris Gris                        </h5>
                                                <p className="card-text">80X160cm</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>

                                               
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


              <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={alfred} className="card-img-top" alt="alfred"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Alfred Gris </h5>
                                            <p className="card-text">80X160cm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={amarisgrey} className="card-img-top" alt="amarisgrey"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Amaris Grey</h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={belgian} className="card-img-top" alt="belgian"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Belgian </h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                            
                                        <div className="card">
                                            <Zoom>
                                                <img src={Breccia} className="card-img-top" alt="Breccia"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Breccia Natural                       </h5>
                                                <p className="card-text">80X160cm</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>

                                               
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



            
              <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={coleurmarble} className="card-img-top" alt="coleurmarble"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Coleur Marble </h5>
                                            <p className="card-text">80X160cm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={colorealmarbel} className="card-img-top" alt="colorealmarbel"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Como Real </h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={dolowhitemarble} className="card-img-top" alt="dolowhitemarble"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Dolo White </h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                            
                                        <div className="card">
                                            <Zoom>
                                                <img src={evancrema} className="card-img-top" alt="evancrema"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Evan Crema                       </h5>
                                                <p className="card-text">80X160cm</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>

                                               
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            
              <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={grecomarble} className="card-img-top" alt="grecomarble"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Greco Marble </h5>
                                            <p className="card-text">80X160cm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={harrodsgrey} className="card-img-top" alt="harrodsgrey"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Harrods Grey </h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={hessiantaupe} className="card-img-top" alt="hessiantaupe"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Hessian Taupe </h5>
                                            <p className="card-text">80X160cm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br />
    </div>
  )
}

export default KajariaNouvellapage